import React from 'react';
import { InputStyle } from './style';

export default function InputResultValue({ value }) {
  return (
    <InputStyle>
      <p>Valor (R$)</p>
      <label>{value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</label>
    </InputStyle>
  );
}
